import React from "react";
import styled from "styled-components";
import logo from "../assets/logo.png";
import dc from "../assets/apply-now.jpg";
import psn from "../assets/guidelines.jpg";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import gg from "../assets/gg.jpeg";

const ImgWrapper = styled.span`
  border: 1px solid #e7e9ed;
  display: inline-block;
  border-radius: 10px;
  height: 60px;
  img {
    border-radius: 6px;
    width: 60px;
    height: 60px;
  }
`;

const ItemWrapper = styled.div`
  h4,
  p {
    color: #fff;
  }
  p {
    font-family: "Roboto", sans-serif;
    font-size: 0.9rem;
    line-height: 18px;
    font-weight: 300;
  }
  h4 {
    font-size: 1.2rem;
    margin-bottom: 5px;
  }
  a {
    &:hover {
      color: #fff;
      opacity: 0.8;
    }
  }
`;

class Home extends React.Component {
  render() {
    return (
      <div>
        <div className="columns is-multiline is-mobile is-centered org pv4 tc ph6-l">
          <div className="column">
            <ImgWrapper className='bg-white'>
              <Link to="/about">
                <img src={logo} alt="" />
              </Link>
            </ImgWrapper>
            <ItemWrapper className="ph4-l">
              <Link className="white f5 fw5" to="/about">
                About DSA
              </Link>
              {/*<p className="pointer f6">
                DSA started with the simple idea to establish an organisation
                that will oversee the activities and oversee the activities and
                secure the nations...
               </p>*/}
            </ItemWrapper>
          </div>

          <div className="column">
            <ImgWrapper>
              <Link to="/application-guidelines">
                <img src={psn} alt="" />
              </Link>
            </ImgWrapper>
            <ItemWrapper className="ph4-l">
              <Link className="white f5 fw5" to="/application-guidelines">
                Application Guidelines
              </Link>
              {/*<p className="pointer f6">
                DSA started with the simple idea to establish an organisation
                that will oversee the activities and oversee the activities and
                secure the nations...
               </p>*/}
            </ItemWrapper>
          </div>

          <div className="column">
            <ImgWrapper>
              <Link to="/how-it-works">
                <img src={dc} alt="" />
              </Link>
            </ImgWrapper>
            <ItemWrapper className="ph4-l">
              <Link className="white f5 fw5" to="/how-it-works">
                How to Apply
              </Link>
              {/*<p className="pointer f6">
                DSA started with the simple idea to establish an organisation
                that will oversee the activities and oversee the activities and
                secure the nations...
               </p>*/}
            </ItemWrapper>
          </div>
        </div>

        <section id="apply" className="pa4 mt4">
          <h2 className="f3 tc fw5">How to Apply for a Job</h2>
          <div className="columns is-multiline mt3 ph7-l">
            <div className="column">
              <figure className="image">
                <img src={gg} alt="" />
              </figure>
            </div>
            <div className="column pt5">
              <div className="w-100 bl b--blue bw2 pl4 mb4">
                <h3 className="f4 fw5">Register to Create an Account</h3>
              </div>
              <div className="w-100 bl b--blue bw2 pl4 mb4">
                <h3 className="f4 fw5">
                  Activate your Account from Email Address
                </h3>
              </div>
              <div className="w-100 bl b--blue bw2 pl4 mb4">
                <h3 className="f4 fw5">Login and complete your application</h3>
              </div>
              <Link to="/vacancies" className="button is-link ml5-l mb5 ph4">
                Apply
              </Link>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    notify: state.notify
  };
};

export default connect(mapStateToProps)(Home);



// WEBPACK FOOTER //
// ./src/pages/index.js